/** The first letters of the first two words: "Admin (fixture)" → "AF", "Rina" → "R". */
export function initials(name: string) {
  return name
    .split(/[^\p{L}\p{N}]+/u)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}
